import React from "react"
import styles from './About.module.scss'
import SText from "../../../components/SText";
import Colors from "../../../components/utils/Colors";
import { NavLink } from "react-router-dom";
import { colorToFilter } from "../../../components/utils/ColorFilter";
import back from "../../../assets/images/cart/goBack.svg";

const About = () => {

    return <div className={ styles.wrapper }>
        <div className={ styles.header }>
            <NavLink to={ '/' }>
                <div className={ styles.goBack }><img style={ { filter: colorToFilter('#383838') } } src={ back } /></div>
            </NavLink>
            <div><SText size={ 26 } lineHeight={ 20 } weight={ 700 } color={ Colors.black }>{ 'О нас' }</SText></div>
        </div>
        <div className={ styles.container }>
            <div className={ styles.contentWrapper }>
                <div>
                    <div style={ { marginBottom: 16 } }>
                        <SText size={ 16 } lineHeight={ 20 }>{ 'Онлайн-магазин натуральных продуктов питания.' }</SText>
                    </div>
                    <div style={ { marginBottom: 16 } }>
                        <SText size={ 16 } lineHeight={ 20 }>{ 'В нашем ассортименте вы можете найти все необходимое для полноценного и здорового питания на любой вкус для всей семьи. Все наши продукты имеют прозрачную историю происхождения и отвечают самым высоким стандартам качества. Надеемся, что вам понравится.' }</SText>
                    </div>
                </div>
                <img src="/images/company.jpg" />

            </div>
        </div>
    </div>
}

export default About